import { createStore } from 'vuex'
import { store as contractErc20 } from './contract/erc20'
import { store as contractRedpack } from './contract/redpack'
import { store as wallet } from './wallet'
import { store as info } from './info'

export default createStore({
  state: {
    keepAliveRoute: [],
    keepAliveInclude: []
  },
  mutations: {
    setKeepAliveRoute (state, pay) {
      state.keepAliveRoute = pay
    },
    setKeepAliveInclude (state, pay) {
      state.keepAliveInclude = pay
    }
  },
  actions: {
  },
  modules: {
    contractErc20,
    contractRedpack,
    wallet,
    info
  }
})
